<template>
  <div v-if="show" class="options">
    <div class="header">
      <a-radio-group v-model:value="modeRadio" size="small" @change="modeRadioChange">
        <a-radio-button :value="1">家具</a-radio-button>
        <a-radio-button :value="2">子区域</a-radio-button>
      </a-radio-group>
      <a-space>
        <a-button type="primary" size="small" @click="handlerSave" v-permission="'room:save'"
          >保存</a-button
        >
      </a-space>
    </div>

    <div v-if="modeRadio === 1" class="config">
      <div class="panel">
        <div class="panel-ct">
          <div class="furnitureTool">
            <a-radio-group v-model:value="sideRadio" size="small">
              <a-radio :style="radioStyle" :value="1">客厅</a-radio>
              <a-radio :style="radioStyle" :value="2">餐厅</a-radio>
              <a-radio :style="radioStyle" :value="3">卧室</a-radio>
              <a-radio :style="radioStyle" :value="4">卫生间</a-radio>
            </a-radio-group>

            <furniture-list
              v-if="sideRadio === 1"
              :icons="livingroomIcons"
              @add="addFurniture"
            ></furniture-list>
            <furniture-list
              v-if="sideRadio === 2"
              :icons="diningroomIcons"
              @add="addFurniture"
            ></furniture-list>
            <furniture-list
              v-if="sideRadio === 3"
              :icons="bedroomIocns"
              @add="addFurniture"
            ></furniture-list>
            <furniture-list
              v-if="sideRadio === 4"
              :icons="bathroomIocns"
              @add="addFurniture"
            ></furniture-list>
          </div>
        </div>

        <div class="panel-hd">
          <div
            >家具列表
            <span v-if="roomStore.localFurnitureItems.length"
              >({{ roomStore.localFurnitureItems.length }})</span
            ></div
          >
          <a-space>
            <a-popconfirm
              v-if="roomStore.localFurnitureItems.length"
              title="确定清空家具吗？"
              @confirm="clearFurniture"
            >
              <a-button size="small" type="link">清空</a-button>
            </a-popconfirm>
          </a-space>
        </div>
        <div class="panel-ct">
          <template v-if="roomStore.localFurnitureItems.length">
            <div
              v-for="(furniture, index) in roomStore.localFurnitureItems"
              :key="index"
              class="list-item"
            >
              <a-collapse v-model:activeKey="furnitureActiveKey" ghost>
                <a-collapse-panel :key="index + 1" :header="`${index + 1}. ${furniture.name} 属性`">
                  <div class="mapConfig">
                    <div class="mapConfig-item">
                      <label class="mapConfig-item-label">家具尺寸：</label>
                      <div class="mapConfig-item-content">
                        <a-space>
                          <a-input-number
                            v-model:value="furniture.width"
                            :min="10"
                            size="small"
                            :style="inputStyle"
                          />
                          <a-input-number
                            v-model:value="furniture.length"
                            :min="10"
                            size="small"
                            :style="inputStyle"
                          />
                        </a-space>
                      </div>
                    </div>

                    <div class="mapConfig-item">
                      <label class="mapConfig-item-label">家具旋转：</label>
                      <div class="mapConfig-item-content">
                        <a-select
                          v-model:value="furniture.rotate"
                          size="small"
                          :style="inputStyle"
                          :getPopupContainer="(trigger: HTMLElement) => trigger.parentNode"
                        >
                          <a-select-option :value="0">0°</a-select-option>
                          <a-select-option :value="90">90°</a-select-option>
                          <a-select-option :value="180">180°</a-select-option>
                          <a-select-option :value="270">270°</a-select-option>
                        </a-select>
                      </div>
                    </div>

                    <div class="mapConfig-item">
                      <label class="mapConfig-item-label">距离雷达：</label>
                      <div class="mapConfig-item-content">
                        <a-space>
                          <a-input-number
                            v-model:value="furniture.x"
                            size="small"
                            :style="inputStyle"
                            @change="
                              () => {
                                if (roomStore.radarAngle === 90 || roomStore.radarAngle === 270) {
                                  const oldWidth = furniture.width
                                  const oldLength = furniture.length
                                  furniture.width = oldLength
                                  furniture.length = oldWidth
                                }
                                roomStore.handlerFurnitureR2C(furniture)
                              }
                            "
                          />
                          <a-input-number
                            v-model:value="furniture.y"
                            size="small"
                            :style="inputStyle"
                            @change="
                              () => {
                                if (roomStore.radarAngle === 90 || roomStore.radarAngle === 270) {
                                  const oldWidth = furniture.width
                                  const oldLength = furniture.length
                                  furniture.width = oldLength
                                  furniture.length = oldWidth
                                }
                                roomStore.handlerFurnitureR2C(furniture)
                              }
                            "
                          />
                        </a-space>
                      </div>
                    </div>

                    <div class="mapConfig-item">
                      <label class="mapConfig-item-label">操作：</label>
                      <div class="mapConfig-item-content">
                        <a-space>
                          <a-popconfirm
                            title="确定删除家具吗？"
                            @confirm="deleteFurniture(furniture.nanoid!)"
                          >
                            <DeleteOutlined />
                          </a-popconfirm>
                        </a-space>
                      </div>
                    </div>
                  </div>
                </a-collapse-panel>
              </a-collapse>
            </div>
          </template>
          <div v-else class="list-empty">暂无家具</div>
        </div>
      </div>
    </div>

    <div v-if="modeRadio === 2" class="info">
      <div class="panel">
        <div class="panel-hd">
          <div
            >子区域列表
            <span v-if="roomStore.localSubRegions.length"
              >({{ roomStore.localSubRegions.length }})</span
            ></div
          >
          <a-space>
            <a-popconfirm
              v-if="roomStore.localSubRegions.length"
              title="确定重置所有区域吗？"
              @confirm="resetAllRegion"
            >
              <a-button size="small" type="link">重置所有区域</a-button>
            </a-popconfirm>
          </a-space>
        </div>
        <div class="panel-ct">
          <template v-if="roomStore.localSubRegions.length">
            <div
              v-for="(region, index) in roomStore.localSubRegions"
              :key="index"
              class="list-item"
            >
              <a-collapse v-model:activeKey="regionActiveKey" ghost>
                <a-collapse-panel :key="index + 1" :header="`子区域 ${index + 1}`">
                  <div class="mapConfig">
                    <div class="mapConfig-item">
                      <div class="mapConfig-item-label">X范围：</div>
                      <div class="mapConfig-item-content">
                        <a-space>
                          <a-input-number
                            v-model:value.trim="region.startXx"
                            :style="inputStyle"
                            size="small"
                            @change="roomStore.handlerRegionR2C(region)"
                            @blur="handlerCompareSize(region.startXx, region.stopXx)"
                          />

                          <a-input-number
                            v-model:value.trim="region.stopXx"
                            :style="inputStyle"
                            size="small"
                            @change="roomStore.handlerRegionR2C(region)"
                            @blur="handlerCompareSize(region.startXx, region.stopXx)"
                          />
                        </a-space>
                      </div>
                    </div>

                    <div class="mapConfig-item">
                      <div class="mapConfig-item-label">Y范围：</div>
                      <div class="mapConfig-item-content">
                        <a-space>
                          <a-input-number
                            v-model:value.trim="region.startYy"
                            :style="inputStyle"
                            size="small"
                            @change="roomStore.handlerRegionR2C(region)"
                            @blur="handlerCompareSize(region.startYy, region.stopYy)"
                          />

                          <a-input-number
                            v-model:value.trim="region.stopYy"
                            :style="inputStyle"
                            size="small"
                            @change="roomStore.handlerRegionR2C(region)"
                            @blur="handlerCompareSize(region.startYy, region.stopYy)"
                          />
                        </a-space>
                      </div>
                    </div>

                    <div class="mapConfig-item">
                      <div class="mapConfig-item-label">Z范围：</div>
                      <div class="mapConfig-item-content">
                        <a-space>
                          <a-input-number
                            v-model:value.trim="region.startZz"
                            :style="inputStyle"
                            size="small"
                            @change="roomStore.handlerRegionR2C(region)"
                            @blur="handlerCompareSize(region.startZz, region.stopZz)"
                          />

                          <a-input-number
                            v-model:value.trim="region.stopZz"
                            :style="inputStyle"
                            size="small"
                            @change="roomStore.handlerRegionR2C(region)"
                            @blur="handlerCompareSize(region.startZz, region.stopZz)"
                          />
                        </a-space>
                      </div>
                    </div>

                    <div class="mapConfig-item">
                      <div class="mapConfig-item-label">区域跟踪：</div>
                      <div class="mapConfig-item-content">
                        <a-switch v-model:checked="region.isTracking" size="small" />
                      </div>
                    </div>

                    <div class="mapConfig-item">
                      <div class="mapConfig-item-label">屏蔽跌倒：</div>
                      <div class="mapConfig-item-content">
                        <a-switch v-model:checked="region.isFalling" size="small" />
                      </div>
                    </div>

                    <div v-if="index === 0" class="mapConfig-item">
                      <div class="mapConfig-item-label">呼吸检测：</div>
                      <div class="mapConfig-item-content">
                        <a-switch v-model:checked="region.isBed" size="small" disabled />
                        <span style="margin-left: 5px; font-size: 12px; color: #aaa"
                          >家具包含床时默认开启</span
                        >
                      </div>
                    </div>

                    <div v-if="false" class="mapConfig-item">
                      <div class="mapConfig-item-label">睡眠检测：</div>
                      <div class="mapConfig-item-content">
                        <a-space>
                          <a-switch
                            :checked="sleepState.enable"
                            size="small"
                            :style="{
                              backgroundColor: sleepState.enable ? '' : '',
                            }"
                            @change="handleSleepStateChange(region.isBed)"
                          />
                          <a-time-picker
                            v-model:value="sleepState.startTime"
                            size="small"
                            :style="inputStyle"
                            placeholder=""
                            format="HH:mm"
                            value-format="HH:mm"
                          />
                          <a-time-picker
                            v-model:value="sleepState.endTime"
                            size="small"
                            :style="inputStyle"
                            placeholder=""
                            format="HH:mm"
                            value-format="HH:mm"
                          />
                          <!-- <a-tooltip v-if="dataUnusual" title="新增睡眠记录">
                            <a-button type="link" size="small" @click="uploadSleepState">
                              新增
                            </a-button>
                          </a-tooltip> -->
                          <!-- <a-tooltip v-else title="保存睡眠记录">
                            <a-button type="link" size="small" @click="saveSleepState">
                              保存
                            </a-button>
                          </a-tooltip> -->
                        </a-space>
                        <div style="font-size: 12px; color: #aaa; line-height: 1">
                          与呼吸检测强关联，呼吸检测开启同步开启
                        </div>
                      </div>
                    </div>

                    <div class="mapConfig-item">
                      <div class="mapConfig-item-label">重置区域：</div>
                      <div class="mapConfig-item-content">
                        <a-button type="link" size="small" @click="resetRegion(region)"
                          >重置</a-button
                        >
                      </div>
                    </div>
                  </div>
                </a-collapse-panel>
              </a-collapse>
            </div>
          </template>
          <div v-else class="list-empty">暂无子区域</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive, computed, inject, watch } from 'vue'
import { useRoomStore } from '@/stores/room'
import { DeleteOutlined } from '@ant-design/icons-vue'
import type { FurnitureIconType } from '@/types/furniture'
import { furnitureIconMapHandler } from '@/const/furniture'
import { nanoid } from 'nanoid'
import { message } from 'ant-design-vue'
import type { LocalSubRegionItem } from '@/api/room/types'
import * as roomApi from '@/api/room'
import * as alarmApi from '@/api/alarm'
import dayjs from 'dayjs'
// import { CloudUploadOutlined, CloudSyncOutlined } from '@ant-design/icons-vue'

defineOptions({ name: 'BaseRadarToolPanel' })
const roomStore = useRoomStore()

const emit = defineEmits(['success', 'reloadAlarm'])

interface Props {
  clientId?: string
  sleepArr?: string[]
}

const props = withDefaults(defineProps<Props>(), {
  clientId: '',
  sleepArr: () => [],
})

const show = defineModel<boolean>('show', { default: false })
const tabKey = defineModel<1 | 2 | 3>('tabKey', { default: 1 })
const modeRadio = ref<1 | 2 | 3>(1)
const sideRadio = ref<1 | 2 | 3 | 4>(1)
const injectRoomId = inject('roomId') as string
const injectDevId = inject('devId') as string

const radioStyle = reactive({
  display: 'flex',
  height: '30px',
  lineHeight: '30px',
})
const inputStyle = computed(() => ({ width: '70px' }))

const regionActiveKey = ref<number[]>([])
const furnitureActiveKey = ref<number[]>([])

const modeRadioChange = (e: Event) => {
  regionActiveKey.value = []
  furnitureActiveKey.value = []
  // if (modeRadio.value === 2) {
  //   fillRegion()
  // }
  tabKey.value = e?.target?.value! as 1 | 2 | 3
}

const resetAllRegion = () => {
  roomStore.localSubRegions = roomStore.localSubRegions.map((region) => {
    return {
      ...region,
      startXx: 0,
      stopXx: 0,
      startYy: 0,
      stopYy: 0,
      startZz: 0,
      stopZz: 0,
    }
  })
  roomStore.localSubRegions.forEach((region) => {
    roomStore.handlerRegionR2C(region)
  })
  message.success('子区域已重置')
}

const resetRegion = (region: LocalSubRegionItem) => {
  const targetRegion = roomStore.localSubRegions.find((r) => r.nanoid === region.nanoid)
  if (targetRegion) {
    Object.assign(targetRegion, {
      startXx: 0,
      stopXx: 0,
      startYy: 0,
      stopYy: 0,
      startZz: 0,
      stopZz: 0,
    })
  }
  roomStore.localSubRegions.forEach((region) => {
    roomStore.handlerRegionR2C(region)
  })
  message.success('重置成功')
}

const fillRegion = () => {
  const existingCount = roomStore.localSubRegions.length || 0
  console.log('fillRegion', existingCount)
  try {
    const targetCount = 6
    if (existingCount < targetCount) {
      const missingCount = targetCount - existingCount
      for (let i = 0; i < missingCount; i++) {
        roomStore.createSubRegion()
      }
    }
  } catch (error) {
    console.log('fillRegion error', error)
  }
}

watch(
  () => show.value,
  (newVal) => {
    if (newVal) {
      fillRegion()
    }
  }
)

// 客厅图标
const livingroomIcons = [
  'living_sofa',
  'living_sofa_single',
  'living_tea_table',
  'living_bookcase',
  'living_tv_stand',
]

// 餐厅图标
const diningroomIcons = [
  'dining_table',
  'dining_table_rect',
  'dining_fridge',
  'dining_chair',
  'bath_door',
]

// 卧室图标
const bedroomIocns = [
  'bed',
  'bed_table',
  'bed_dressing_chair',
  'bed_dressing_mirror',
  'bed_cabinet',
]

// 卫生间图标
const bathroomIocns = ['bath_basin', 'bath_shower', 'bath_toilet']

const addFurniture = (icon: FurnitureIconType) => {
  const iconMap = furnitureIconMapHandler(icon)
  const furnitureItem = {
    nanoid: nanoid(8),
    name: iconMap.name,
    type: icon,
    width: iconMap.width,
    length: iconMap.height,
    rotate: 0,
    x: 0,
    y: 0,
    left: 0,
    top: 0,
  }
  console.log('addFurniture添加家具', icon, furnitureItem)
  const hasBed = roomStore.localFurnitureItems.some((i) => i.type === 'bed')
  if (hasBed && icon === 'bed') {
    message.warning('已添加床，不要添加多个床')
    return
  }
  roomStore.localFurnitureItems.push(furnitureItem)
}

const clearFurniture = () => {
  roomStore.localFurnitureItems = []
  roomStore.localSubRegions[0].isBed = false
  roomStore.localSubRegions[0].isLowSnr = 0
}

function deleteFurniture(nanoid: string) {
  const hasBed = roomStore.localFurnitureItems.some((i) => i.nanoid === nanoid && i.type === 'bed')
  if (hasBed && roomStore.localSubRegions.length) {
    roomStore.localSubRegions = roomStore.localSubRegions.map((region) => ({
      ...region,
      isBed: false,
    }))
  }
  roomStore.localFurnitureItems = roomStore.localFurnitureItems.filter((i) => i.nanoid !== nanoid)
  // 如果删除的是床，就将子区域设置为普通区域
  if (hasBed && roomStore.localSubRegions.length) {
    roomStore.localSubRegions[0].isBed = false
    roomStore.localSubRegions[0].isLowSnr = 0
  }
}

// 范围值大小提示
const handlerCompareSize = (start: number, stop: number) => {
  if (start > stop) {
    message.error('开始值不能大于结束值')
  }
}

const handlerSave = async () => {
  console.log('保存配置', {
    furnitures: roomStore.localFurnitureItems,
    subRegions: roomStore.localSubRegions,
  })

  try {
    // const hasBed = roomStore.localFurnitureItems.some((i) => i.type === 'bed')
    // if (!roomStore.localSubRegions[0]?.isBed) {
    //   console.log('未开启睡眠检测, 跳过睡眠')
    // } else {
    //   if (noSleepPlan.value) {
    //     await uploadSleepState()
    //   } else if (hasBed) {
    //     await saveSleepState()
    //   } else {
    //     console.log('家具中无床, 跳过睡眠')
    //   }
    // }
  } catch (error) {
    console.error('保存睡眠检测失败', error)
    return
  }

  const furnitures = roomStore.localFurnitureItems.map((item) => {
    const oldWidth = item.width
    const oldLength = item.length
    return {
      name: item.name,
      type: item.type,
      width: roomStore.radarAngle === 90 || roomStore.radarAngle === 270 ? oldLength : oldWidth,
      length: roomStore.radarAngle === 90 || roomStore.radarAngle === 270 ? oldWidth : oldLength,
      rotate: item.rotate,
      x: item.x,
      y: item.y,
      left: item.left,
      top: item.top,
    }
  })

  /**
   * 保存子区域
   * 1、子区域有值，presenceEnterDuration、presenceExitDuration为3
   * 2、子区域无值，presenceEnterDuration、presenceExitDuration为0
   * ps: 有值指的是：startXx stopXx startYy stopYy 均不为0
   */
  const subRegions = roomStore.localSubRegions.map((region) => {
    console.log('子区域🌸🌸🌸🌸🌸🌸🌸🌸', region)
    return {
      x_cm_start: region.startXx,
      x_cm_stop: region.stopXx,
      y_cm_start: region.startYy,
      y_cm_stop: region.stopYy,
      z_cm_start: region.startZz,
      z_cm_stop: region.stopZz,
      is_low_snr: Number(region.isBed),
      is_door: region.isDoor,
      presence_enter_duration:
        region.startXx !== 0 || region.stopXx !== 0 || region.startYy !== 0 || region.stopYy !== 0
          ? 3
          : 0,
      presence_exit_duration:
        region.startXx !== 0 || region.stopXx !== 0 || region.startYy !== 0 || region.stopYy !== 0
          ? 3
          : 0,
      track_presence: Number(region.isTracking),
      exclude_falling: Number(region.isFalling),
    }
  })

  try {
    const res = await roomApi.saveRoomInfo({
      roomId: injectRoomId,
      devId: injectDevId,
      furnitures,
      subRegions,
    })
    console.log('保存所有配置 ✅', res)
    message.success('保存成功')
    show.value = false
    emit('success', res)
  } catch (error) {
    console.error('保存所有配置 ❌', error)
  }
}

const sleepState = ref({
  enable: false,
  startTime: dayjs('20:00', 'HH:mm'),
  endTime: dayjs('10:00', 'HH:mm'),
})

watch(
  () => roomStore.localSubRegions.some((item) => item.isBed),
  (newVal) => {
    sleepState.value.enable = newVal
  }
)

/**
 * 保存睡眠检测
 */
// const saveSleepState = () => {
//   if (!roomStore.localSubRegions[0]?.isBed) {
//     return Promise.resolve('未开启睡眠检测')
//   }
//   return new Promise(async (resolve, reject) => {
//     // if (
//     //   roomStore.localSubRegions[0].startXx === 0 &&
//     //   roomStore.localSubRegions[0].stopXx === 0 &&
//     //   roomStore.localSubRegions[0].startYy === 0 &&
//     //   roomStore.localSubRegions[0].stopYy === 0
//     // ) {
//     //   message.error('请先配置当前子区域')
//     //   reject({
//     //     message: '请先配置当前子区域',
//     //     data: roomStore.localSubRegions[0],
//     //   })
//     //   return
//     // }

//     const localRegion = [
//       roomStore.localSubRegions[0].startXx,
//       roomStore.localSubRegions[0].stopYy,
//       roomStore.localSubRegions[0].pixelWidth,
//       roomStore.localSubRegions[0].pixelHeight,
//     ]

//     const params = {
//       alarmPlanId: props?.sleepArr[0]?.id || undefined,
//       clientId: props.clientId,
//       name: '睡眠检测' + '_' + props.clientId,
//       eventVal: 10,
//       alarmTimePlan: {
//         startDate: '2025-01-01',
//         stopDate: '2099-12-31',
//         timeRange: '',
//         monthDays: JSON.stringify([]),
//         weekdays: JSON.stringify([1, 2, 3, 4, 5, 6, 7]),
//       },
//       param: JSON.stringify({
//         start_time: dayjs(sleepState.value.startTime, 'HH:mm').format('HH:mm'),
//         end_time: dayjs(sleepState.value.endTime, 'HH:mm').format('HH:mm'),
//       }),
//       region: JSON.stringify(localRegion),
//       linkagePushWechatService: 0,
//       enable: sleepState.value.enable === true ? 1 : 0,
//     }
//     console.log('saveSleepState', params)
//     try {
//       const res = await alarmApi.saveAlarmPlan(params)
//       console.log('保存检测区域成功', res)
//       message.success('保存成功')
//       resolve(res)
//       emit('reloadAlarm')
//     } catch (error) {
//       console.error('保存检测区域失败', error)
//       reject(error)
//     }
//   })
// }

// const noSleepPlan = ref(false)
const noSleepPlan = computed(() => !Boolean(props?.sleepArr[0]?.id))
/**
 * 回显检测区域
 */
const echoSleepState = () => {
  console.log('echoSleepState', props?.sleepArr[0])
  // noSleepPlan.value = !Boolean(props?.sleepArr[0]?.id)
  if (props?.sleepArr[0]?.id) {
    const param = JSON.parse(props?.sleepArr[0]?.data?.param ?? '[]')

    sleepState.value.enable = props?.sleepArr[0]?.data?.enable === 1
    sleepState.value.startTime = param?.start_time
      ? dayjs(param?.start_time ?? '', 'HH:mm').format('HH:mm')
      : ''
    sleepState.value.endTime = param?.end_time
      ? dayjs(param?.end_time ?? '', 'HH:mm').format('HH:mm')
      : ''
  }
}
watch(() => props.sleepArr, echoSleepState)

const uploadSleepState = async () => {
  emit('reloadAlarm', noSleepPlan.value)
  // if (noSleepPlan.value) {
  //   await saveSleepState()
  // }
}

const handleSleepStateChange = (hasBed: boolean) => {
  if (!hasBed) {
    message.error('请先添加家具“床”')
    sleepState.value.enable = false
    return
  }
  sleepState.value.enable = !sleepState.value.enable
}
</script>

<style scoped lang="less">
.options {
  width: 360px;
  min-height: 500px;
  background-color: #fefefe;
  border-radius: 10px;
  padding: 12px;
  position: relative;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  position: absolute;
  right: -380px;
  z-index: 999;

  .close {
    position: absolute;
    top: 8px;
    right: 12px;
    font-size: 22px;
    font-weight: 600;
    line-height: 1;
    color: #999;
    cursor: pointer;
    transition: color 0.2s;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
  }
}

.panel {
  margin-bottom: 12px;
  &-hd {
    font-size: 12px;
    font-weight: 600;
    color: #666;
    line-height: 1.5;
    padding: 5px 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .ant-btn-link {
      font-size: 12px;
      line-height: 1.5;
      padding: 0;
    }
  }
  &-ct {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-height: 30px;
    max-height: 500px;
    overflow-y: auto;

    // 滚动条不遮挡内容
    ::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    ::-webkit-scrollbar-track {
      background-color: transparent;
    }
    ::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 2px;
    }

    .furnitureTool {
      display: flex;
      justify-content: space-between;
      background-color: #f5f5f5;
      padding: 8px;
      border-radius: 8px;
      min-height: 250px;

      .furnitureList {
        flex-grow: 1;
      }
    }

    .subregionTool {
      display: flex;
      align-items: center;
      background-color: #f5f5f5;
      padding: 10px 12px;
      border-radius: 8px;
      font-size: 14px;
      color: #333;
    }
  }
  &:last-child {
    margin-bottom: 0;
  }

  .list-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-radius: 8px;
    background-color: #f5f5f5;
    cursor: pointer;
  }

  .list-empty {
    padding: 8px 12px;
    font-size: 14px;
    color: #999;
    border-radius: 8px;
    background-color: #f5f5f5;
  }
}

.mapConfig {
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 0 12px 12px;
  &-header {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .title {
      font-size: 14px;
      font-weight: 600;
      line-height: 24px;
    }
    .close {
      font-size: 14px;
      color: #666;
      cursor: pointer;
      position: relative;
      top: -5px;
    }
  }

  &-item {
    display: flex;
    line-height: 30px;
    &-label {
      color: #888;
      min-width: 80px;
    }
    &-content {
      color: #555;
    }

    :deep(.ant-btn-link) {
      padding: 0;
    }
  }
}

:deep(.ant-collapse) {
  width: 100%;
}
:deep(.ant-collapse .ant-collapse-content > .ant-collapse-content-box) {
  padding: 0;
}
:deep(.ant-collapse > .ant-collapse-item > .ant-collapse-header) {
  padding: 5px;
  user-select: none;
}
</style>
